export { default } from './CanaisAtendimentoConteudoBlog';
